
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://kyyihbioaxmkvhqgewxq.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt5eWloYmlvYXhta3ZocWdld3hxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEzNDgwMjQsImV4cCI6MjA1NjkyNDAyNH0.vO63X7zHeiGkeUyR2s98KoJ1eTDzRmKpMrCWMb2i8yk';
const supabaseServiceRoleKey = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt5eWloYmlvYXhta3ZocWdld3hxIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0MTM0ODAyNCwiZXhwIjoyMDU2OTI0MDI0fQ.FSvgCofkDzRbXkyYfVllUgNOSg-Hs3GxQt4Wxilj3sM';

// Add Google Maps API key as a global constant
export const GOOGLE_MAPS_API_KEY = 'AIzaSyDstR0CAhqB8EDENlx4KZ-fGoyg1g0DYzQ';

// Initialize the Supabase client with anon key (for regular operations)
export const supabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true
    }
  }
);

// Create an admin client with service role key
// This should only be used on the server or in admin-only components
export const createAdminClient = () => {
  if (!supabaseServiceRoleKey) {
    console.warn('Service role key not available, falling back to anonymous client');
    return supabase;
  }
  
  return createClient<Database>(
    supabaseUrl, 
    supabaseServiceRoleKey,
    {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    }
  );
};

// Admin client instance (use carefully and only in admin contexts)
export const adminClient = createAdminClient();

// Export a way to access the URL safely
export const getSupabaseUrl = () => supabaseUrl;
